import PasswordInput from '../components/PasswordInput';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const RECAPTCHA_SITE_KEY = '6LdICsMsAAAAADHlDIfcI35cznYw3ZpWZuv81w2d';

const telefonFormatla = (deger) => {
  const sadeceSayi = deger.replace(/\D/g, '').slice(0, 11);
  if (sadeceSayi.length === 0) return '';
  if (sadeceSayi.length <= 1) return '0';
  if (sadeceSayi.length <= 4) return '0(' + sadeceSayi.slice(1);
  if (sadeceSayi.length <= 7) return '0(' + sadeceSayi.slice(1,4) + ')' + sadeceSayi.slice(4);
  if (sadeceSayi.length <= 9) return '0(' + sadeceSayi.slice(1,4) + ')' + sadeceSayi.slice(4,7) + ' ' + sadeceSayi.slice(7);
  return '0(' + sadeceSayi.slice(1,4) + ')' + sadeceSayi.slice(4,7) + ' ' + sadeceSayi.slice(7,9) + ' ' + sadeceSayi.slice(9,11);
};

const Adim = ({ numara, baslik, aktif, tamamlandi }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
    <div style={{
      width: '28px', height: '28px', borderRadius: '50%', flexShrink: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: '13px', fontWeight: '600',
      background: tamamlandi ? 'var(--yesil)' : aktif ? 'var(--mavi)' : 'var(--gri-200)',
      color: tamamlandi || aktif ? 'white' : 'var(--gri-400)',
    }}>
      {tamamlandi ? '✓' : numara}
    </div>
    <span style={{ fontSize: '12px', fontWeight: aktif ? '600' : '400', color: aktif ? 'var(--mavi)' : tamamlandi ? 'var(--yesil)' : 'var(--gri-400)', whiteSpace: 'nowrap' }}>
      {baslik}
    </span>
  </div>
);

const AdayKayitPage = ({ girisSayfasinaGit }) => {
  const [adim, setAdim] = useState(1);
  const [form, setForm] = useState({
    ad:'', soyad:'', email:'', telefon:'', dogum_tarihi:'',
    emeklilik_durumu:'emekli_degil', maas_beklentisi:'',
    sehir:'', ilce:'', sifre:'', basvuru_pozisyon:'', basvuru_musteri:''
  });
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');
  const captchaRef = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    if (adim !== 3) return;
    const loadCaptcha = () => {
      if (captchaRef.current && window.grecaptcha && widgetId.current === null) {
        widgetId.current = window.grecaptcha.render(captchaRef.current, {
          sitekey: RECAPTCHA_SITE_KEY,
          callback: (token) => setCaptchaToken(token),
          'expired-callback': () => setCaptchaToken('')
        });
      }
    };
    if (window.grecaptcha) {
      loadCaptcha();
    } else {
      window.onRecaptchaLoadKayit = loadCaptcha;
      if (!document.querySelector('script[src*="recaptcha"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoadKayit&render=explicit';
        script.async = true; script.defer = true;
        document.head.appendChild(script);
      } else {
        setTimeout(loadCaptcha, 500);
      }
    }
  }, [adim]);

  const f = (alan, val) => setForm({ ...form, [alan]: val });

  const adim1Gecerli = form.ad && form.soyad && form.email && form.telefon;
  const adim2Gecerli = form.basvuru_pozisyon && form.basvuru_musteri;

  const sonrakiAdim = () => {
    setHata('');
    if (adim === 1 && !adim1Gecerli) { setHata('Ad, soyad, e-posta ve telefon zorunludur.'); return; }
    if (adim === 2 && !adim2Gecerli) { setHata('Basvurulan pozisyon ve firma zorunludur.'); return; }
    setAdim(adim + 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) { setHata('Lutfen robot olmadiginizi dogrulayin.'); return; }
    if (!form.sifre || form.sifre.length < 8) { setHata('Sifre en az 8 karakter olmalidir.'); return; }
    setHata(''); setYukleniyor(true);
    try {
      await axios.post('/api/adaylar/kayit', { ...form, captchaToken });
      const girisRes = await axios.post('/api/adaylar/giris', { email: form.email, sifre: form.sifre });
      const { token, kullanici: k } = girisRes.data;
      localStorage.setItem('token', token);
      localStorage.setItem('kullanici', JSON.stringify(k));
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      window.location.reload();
    } catch(err) {
      setHata(err.response?.data?.hata || 'Kayit basarisiz.');
      if (window.grecaptcha && widgetId.current !== null) {
        try { window.grecaptcha.reset(widgetId.current); } catch(e) {}
      }
      setCaptchaToken('');
    } finally { setYukleniyor(false); }
  };

  return (
    <div className="giris-wrap" style={{ padding: '1rem' }}>
      <div style={{ width: '100%', maxWidth: '560px', margin: '0 auto' }}>

        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ width: '52px', height: '52px', borderRadius: '14px', background: 'var(--mavi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a56db" strokeWidth="1.5">
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z"/>
            </svg>
          </div>
          <h1 style={{ fontSize: '22px', fontFamily: 'DM Serif Display, serif', marginBottom: '4px' }}>Valure HR</h1>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Aday basvuru formu</p>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2rem', gap: '4px' }}>
          <Adim numara={1} baslik="Kisisel" aktif={adim === 1} tamamlandi={adim > 1} />
          <div style={{ flex: 1, height: '2px', background: adim > 1 ? 'var(--yesil)' : 'var(--gri-200)', maxWidth: '40px' }} />
          <Adim numara={2} baslik="Basvuru" aktif={adim === 2} tamamlandi={adim > 2} />
          <div style={{ flex: 1, height: '2px', background: adim > 2 ? 'var(--yesil)' : 'var(--gri-200)', maxWidth: '40px' }} />
          <Adim numara={3} baslik="Guvenlik" aktif={adim === 3} tamamlandi={false} />
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          {hata && <div className="alert alert-error" style={{ marginBottom: '1rem' }}>{hata}</div>}

          {adim === 1 && (
            <div>
              <div style={{ marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
                <h3 style={{ fontSize: '15px', fontWeight: '600' }}>Kisisel Bilgiler</h3>
                <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>Temel iletisim bilgilerinizi girin</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                  <div className="form-group">
                    <label>Ad *</label>
                    <input type="text" value={form.ad} onChange={e => f('ad', e.target.value)} required autoComplete="off" placeholder="Adiniz" />
                  </div>
                  <div className="form-group">
                    <label>Soyad *</label>
                    <input type="text" value={form.soyad} onChange={e => f('soyad', e.target.value)} required autoComplete="off" placeholder="Soyadiniz" />
                  </div>
                </div>
                <div className="form-group">
                  <label>E-posta *</label>
                  <input type="email" value={form.email} onChange={e => f('email', e.target.value)} required autoComplete="off" placeholder="ornek@mail.com" />
                </div>
                <div className="form-group">
                  <label>Telefon *</label>
                  <input type="tel" value={form.telefon} onChange={e => f('telefon', telefonFormatla(e.target.value))} placeholder="0(5xx)xxx xx xx" required autoComplete="off" maxLength={15} />
                  <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginTop: '3px' }}>Format: 0(542)387 19 32</div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                  <div className="form-group">
                    <label>Dogum Tarihi</label>
                    <input type="date" value={form.dogum_tarihi} onChange={e => f('dogum_tarihi', e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label>Emeklilik Durumu</label>
                    <select value={form.emeklilik_durumu} onChange={e => f('emeklilik_durumu', e.target.value)}>
                      <option value="emekli_degil">Emekli Degilim</option>
                      <option value="emekli">Emekliyim</option>
                      <option value="emekliligi_hak_kazandim">Emekliliye Hak Kazandim</option>
                    </select>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                  <div className="form-group">
                    <label>Ikamet Sehri</label>
                    <input type="text" value={form.sehir} onChange={e => f('sehir', e.target.value)} placeholder="Istanbul" autoComplete="off" />
                  </div>
                  <div className="form-group">
                    <label>Ilce</label>
                    <input type="text" value={form.ilce} onChange={e => f('ilce', e.target.value)} placeholder="Kadikoy" autoComplete="off" />
                  </div>
                </div>
              </div>
            </div>
          )}

          {adim === 2 && (
            <div>
              <div style={{ marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
                <h3 style={{ fontSize: '15px', fontWeight: '600' }}>Basvuru Bilgileri</h3>
                <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>Hangi pozisyon ve firma icin basvuruyorsunuz?</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div className="form-group">
                  <label>Basvurulan Pozisyon *</label>
                  <input type="text" value={form.basvuru_pozisyon} onChange={e => f('basvuru_pozisyon', e.target.value)} placeholder="or. Yazilim Gelistirici" required autoComplete="off" />
                </div>
                <div className="form-group">
                  <label>Basvurulan Musteri *</label>
                  <input type="text" value={form.basvuru_musteri} onChange={e => f('basvuru_musteri', e.target.value)} placeholder="or. ABC Teknoloji" required autoComplete="off" />
                </div>
                <div className="form-group">
                  <label>Maas Beklentisi (Net TL)</label>
                  <input type="text" value={form.maas_beklentisi} onChange={e => f('maas_beklentisi', e.target.value)} placeholder="or. 25.000" autoComplete="off" />
                </div>
                {(form.ad || form.email) && (
                  <div style={{ padding: '12px', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', fontSize: '13px' }}>
                    <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Bilgileriniz</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', color: 'var(--yazi)' }}>
                      {form.ad && <span>{form.ad} {form.soyad}</span>}
                      {form.email && <span>{form.email}</span>}
                      {form.telefon && <span>{form.telefon}</span>}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {adim === 3 && (
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
                <h3 style={{ fontSize: '15px', fontWeight: '600' }}>Guvenlik</h3>
                <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>Hesabiniz icin guvenli bir sifre belirleyin</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div className="form-group">
                  <label>Sifre *</label>
                  <PasswordInput value={form.sifre} onChange={e => f('sifre', e.target.value)} required minLength={8} autoComplete="new-password" placeholder="En az 8 karakter" />
                  {form.sifre && form.sifre.length < 8 && (
                    <div style={{ fontSize: '12px', color: 'var(--kirmizi)', marginTop: '4px' }}>En az 8 karakter giriniz</div>
                  )}
                  {form.sifre && form.sifre.length >= 8 && (
                    <div style={{ fontSize: '12px', color: 'var(--yesil)', marginTop: '4px' }}>Sifre uygun</div>
                  )}
                </div>

                <div style={{ padding: '12px', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', fontSize: '12px' }}>
                  <div style={{ fontWeight: '600', marginBottom: '6px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '11px' }}>Basvuru Ozeti</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', color: 'var(--yazi)' }}>
                    <span>{form.ad} {form.soyad}</span>
                    <span>{form.email}</span>
                    <span>{form.basvuru_pozisyon}</span>
                    <span>{form.basvuru_musteri}</span>
                  </div>
                </div>

                <div ref={captchaRef}></div>
                {!captchaToken && <div style={{ fontSize: '12px', color: 'var(--kirmizi)' }}>Lutfen robot dogrulamasini tamamlayin.</div>}

                <button type="submit" className="btn btn-primary" disabled={yukleniyor || !captchaToken || form.sifre.length < 8} style={{ width: '100%', padding: '0.75rem' }}>
                  {yukleniyor ? 'Kayit yapiliyor...' : 'Kayit Ol ve Basvur'}
                </button>
              </div>
            </form>
          )}

          {adim < 3 && (
            <div style={{ display: 'flex', gap: '8px', marginTop: '1.5rem' }}>
              {adim > 1 && (
                <button type="button" className="btn btn-secondary" onClick={() => { setAdim(adim - 1); setHata(''); }}>Geri</button>
              )}
              <button type="button" className="btn btn-primary" onClick={sonrakiAdim} style={{ flex: 1 }}>
                {adim === 2 ? 'Devam' : 'Sonraki Adim'}
              </button>
            </div>
          )}
          {adim === 3 && (
            <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setAdim(2); setHata(''); }} style={{ marginTop: '0.75rem', width: '100%' }}>Geri Don</button>
          )}
        </div>

        <p style={{ textAlign: 'center', fontSize: '13px', color: 'var(--yazi-ikincil)' }}>
          Hesabiniz var mi?{' '}
          <button type="button" style={{ background: 'none', border: 'none', color: 'var(--mavi)', cursor: 'pointer', fontSize: '13px' }} onClick={girisSayfasinaGit}>
            Giris Yapin
          </button>
        </p>
      </div>
    </div>
  );
};
export default AdayKayitPage;
